import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { ClipboardCopy, Send } from 'lucide-react';
import { toast } from 'sonner';

export const SentEmailDialog = ({ record, onClose }) => {
  if (!record) return null;
  const subject = record.email_subject || '';
  const body = record.email_body || '';
  const pharma = record.on_behalf_of_pharma || '';
  const behalfName = record.on_behalf_of_name || record.on_behalf_of || '';
  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(`Subject: ${subject}\n\n${body}`);
      toast.success('Email copied to clipboard');
    } catch { toast.error('Copy failed'); }
  };
  return (
    <Dialog open onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="sent-email-dialog">
        <DialogHeader>
          <DialogTitle className="text-base font-bold flex items-center gap-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
            <Send className="w-4 h-4 text-sky-500" /> Sent Email Copy
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          {(pharma || behalfName) && (
            <div className="px-3 py-2 rounded-lg bg-violet-50 border border-violet-200 text-xs text-violet-800" data-testid="sent-email-on-behalf">
              Sent on behalf of <span className="font-semibold">{pharma || behalfName}</span>
              {pharma && behalfName ? <> · {behalfName}</> : null}
            </div>
          )}
          <div className="flex flex-wrap items-center gap-2 text-xs text-slate-500">
            {record.contact_email && (
              <span>To: <span className="text-slate-700">{record.contact_name ? `${record.contact_name} <${record.contact_email}>` : record.contact_email}</span></span>
            )}
            {(record.date || record.created_at) && <span>· {new Date(record.date || record.created_at).toLocaleString()}</span>}
            {record.email_body_is_template && (
              <Badge variant="outline" className="text-[10px] bg-amber-50 text-amber-700 border-amber-200" title="Per-recipient personalization wasn't stored for this older send — this is the campaign template that was used.">Template copy</Badge>
            )}
          </div>
          <div>
            <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider mb-1">Subject</p>
            <p className="text-sm font-medium text-slate-800" data-testid="sent-email-subject">{subject || '—'}</p>
          </div>
          <div>
            <p className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider mb-1">Body</p>
            <div className="border border-slate-200 rounded-lg bg-slate-50/60 p-4 text-[13px] leading-relaxed text-slate-700 whitespace-pre-wrap max-h-[380px] overflow-y-auto" data-testid="sent-email-body">
              {body || 'Email body was not stored for this send.'}
            </div>
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="outline" size="sm" onClick={copyEmail} className="text-xs" data-testid="sent-email-copy-btn">
              <ClipboardCopy className="w-3.5 h-3.5 mr-1.5" /> Copy Email
            </Button>
            <Button size="sm" onClick={onClose} className="text-xs bg-[#0A1128] text-white hover:bg-slate-800" data-testid="sent-email-close-btn">Close</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SentEmailDialog;
